var _camelize = require('underscore.string/camelize');
var _curry = require('chickencurry');

module.exports = _curry(function camelize(str) {
  return _camelize(str, true);
});



//////////////////
// WEBPACK FOOTER
// ./node_modules/underscore.string.fp/camelize.js
// module id = 1029
// module chunks = 2